import { findHolderMember, isMuttavatteenSabilType } from "./sabil-holder-audit";
import { formatDisplayWhatsappNo, normalizeWhatsappNo } from "./sabil-household-members";

type SabilRecordLike = Record<string, unknown> | undefined;

function nonEmpty(value: unknown): string | undefined {
  const text = String(value ?? "").trim();
  return text.length ? text : undefined;
}

/** Prefer stored sabil name, then Mutawatteen leftover holder row, then ITS directory. */
export function resolveSabilDisplayName(record: SabilRecordLike): string | undefined {
  const fromSabil = nonEmpty(record?.name);
  if (fromSabil) {
    return fromSabil;
  }
  if (isMuttavatteenSabilType(record?.sabilType as string | undefined)) {
    const members = Array.isArray(record?.householdMembers) ? record.householdMembers : [];
    const fromHolder = nonEmpty(findHolderMember(members)?.name);
    if (fromHolder) {
      return fromHolder;
    }
  }
  return nonEmpty((record?.itsdata as { Full_Name?: unknown } | undefined)?.Full_Name);
}

/** Prefer stored sabil ITS, then Mutawatteen leftover holder row, then ITS directory. */
export function resolveSabilDisplayItsNo(record: SabilRecordLike): string | undefined {
  const fromSabil = nonEmpty(record?.itsNo);
  if (fromSabil) {
    return fromSabil;
  }
  if (isMuttavatteenSabilType(record?.sabilType as string | undefined)) {
    const members = Array.isArray(record?.householdMembers) ? record.householdMembers : [];
    const fromHolder = nonEmpty(findHolderMember(members)?.itsNo);
    if (fromHolder) {
      return fromHolder;
    }
  }
  return nonEmpty((record?.itsdata as { ITS_ID?: unknown } | undefined)?.ITS_ID);
}

/** Mohalla from sabil record only — Mutawatteen are often absent from the local ITS dump. */
export function resolveSabilDisplayMohallah(record: SabilRecordLike): string | undefined {
  return nonEmpty(record?.mohallah);
}

/** Holder WhatsApp: sabil column first, then leftover isHof row. */
export function resolveHolderWhatsapp(record: SabilRecordLike): string | undefined {
  if (!isMuttavatteenSabilType(record?.sabilType as string | undefined)) {
    return undefined;
  }
  const fromSabil = normalizeWhatsappNo(record?.holderWhatsappNo);
  if (fromSabil) {
    return formatDisplayWhatsappNo(fromSabil);
  }
  const members = Array.isArray(record?.householdMembers) ? record.householdMembers : [];
  const fromMember = nonEmpty(findHolderMember(members)?.whatsappNo);
  return fromMember ? formatDisplayWhatsappNo(fromMember) : undefined;
}
